import { useQuery } from "@tanstack/react-query";
import TenantAPI from "../../api/TenantAPI";
import { Index } from "../../../types/GlobalInterfaces";

const useGetIndexes = (
  moduleAPIName: string,
  tenantID: string,
  isSupportal: boolean
) => {
  const indexes = useQuery<Index[]>({
    queryKey: [tenantID, moduleAPIName],
    queryFn: () =>
      TenantAPI.getIndexes(moduleAPIName, isSupportal ? tenantID : "").then(
        (data) => data.data.data.indexes
      ),
  });

  return {
    indexes: indexes.data,
    indexesLoading: indexes.isLoading,
  };
};

export default useGetIndexes;
